import Vue from 'vue'

// 样式单位rpx
function unit(target) {
  return `${target / 7.5}vw`
}

Vue.prototype.$unit = unit
